import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'admin-navigation',
	templateUrl: 'admin-navigation.html'
})

export class AdminNavigation{

	@Input() template: string = null;
	@Output() templateChange: EventEmitter<string> = new EventEmitter<string>();

	constructor()
	{
		
	}

}



// WEBPACK FOOTER //
// ./src/partials/admin/admin-navigation/admin-navigation.ts